import React, {useRef, useEffect} from 'react'
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import BlockWebsiteCategoryPic from '../../../../assets/images/block-website-category.png';

const BlockWebsiteCategory = ({showModal, closeModal}) => {
    const modalRef = useRef();
  
    useEffect(() => {
      if (showModal) {
          const modal = new Modal(modalRef.current, {
              backdrop: 'static',
              keyboard: false,
            });
          modal.show();
      }
    }, [showModal]);
  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
         <div className="modal-dialog modal-dialog-centered modal-sm">
             <div className="modal-content">
                <div className="modal-header border-0 pb-0">
                    <h6 className="modal-title text-blue-900">Block website category</h6>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
                </div>
                <div className="modal-body">
                    <img className='d-block mx-auto' src={BlockWebsiteCategoryPic} alt='' />
                    <h6 className='my-6 text-center text-blue-900'>An access to the *Website Category Name* <br/> has been restricted for *Child Name*</h6>
                    <button className='btn btn-primary w-100' data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}><span className='btn-upper-case'>got it</span></button>
                </div>
             </div>
         </div>
     </div>
  )
}

export default BlockWebsiteCategory